const getPaddedDurationFromMilliSeconds = (millis) => {
    const seconds = Math.floor(millis / 1000) % 60;
    const minutes = Math.floor(millis / 1000 / 60) % 60;
    const hours = Math.floor(millis / 1000 / 60 / 60) % 60;

    return `${hours < 10 && hours > 0 ? "0" : ""}${
        hours <= 0 ? "" : `${hours}:`
    }${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};

const exported = {
    getPaddedDurationFromMilliSeconds,
};

export default exported;
export { getPaddedDurationFromMilliSeconds };
